import React, { useState } from 'react'
import { Loader2, Upload } from 'lucide-react'
import processAnsesPDF from '../../parsers/ansesParser'

export default function Dropzone({ onProcessed, onProgress, parserProfile = 'default' }) {
  const [dragOver, setDragOver] = useState(false)
  const [loading, setLoading] = useState(false)

  const processFile = async (file) => {
    if (!file) return
    setLoading(true)
    onProgress?.('Analizando empresas...')
    const data = await processAnsesPDF(file, { profile: parserProfile })
    onProgress?.('Validando periodos...')
    onProcessed?.(data)
    onProgress?.('Calculando Gaps...')
    setLoading(false)
  }

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDragOver(true) }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => { e.preventDefault(); setDragOver(false); processFile(e.dataTransfer.files?.[0]) }}
      className={`rounded-xl border-2 border-dashed bg-white p-8 text-center shadow-sm ${dragOver ? 'border-blue-500' : 'border-slate-300'}`}
    >
      <Upload className="mx-auto mb-2 h-8 w-8 text-blue-600" />
      <p className="text-sm text-slate-600">Arrastra el PDF de Historia Laboral o selecciona archivo</p>
      <label className="mt-3 inline-flex h-10 cursor-pointer items-center rounded-lg bg-blue-600 px-4 text-white transition-all duration-200 hover:bg-blue-700 active:scale-95">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Cargar PDF'}
        <input type="file" accept="application/pdf,.pdf" className="hidden" onChange={(e) => processFile(e.target.files?.[0])} />
      </label>
    </div>
  )
}
